import { Box, Flex, Text, Icon } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";

interface IdeaPublishedNotification {
  ideaId?: number;
  ideaTitle: string;
  author: string;
}

const IdeaPublishedMarquee = ({
  notification,
  onClick,
}: {
  notification: IdeaPublishedNotification;
  onClick: () => void;
}) => {
  return (
    <Flex
      align="center"
      overflow="hidden"
      borderRadius="10px"
      bg="linear-gradient(90deg, #006838 0%, #0C8F4F 100%)"
      cursor="pointer"
      onClick={onClick}
      h="44px"
      position="relative"
      _hover={{ opacity: 0.92 }}
      transition="opacity 0.15s ease"
    >
      <Flex
        align="center"
        gap={2}
        px={4}
        h="100%"
        bg="whiteAlpha.200"
        flexShrink={0}
        zIndex={1}
        borderRight="1px solid"
        borderColor="whiteAlpha.300"
      >
        <Text
          className="font-poppins text_medium text_xsm"
          color="white"
          whiteSpace="nowrap"
          textTransform="uppercase"
          letterSpacing="0.5px"
        >
          Published
        </Text>
      </Flex>

      <Box flex={1} overflow="hidden" position="relative" h="100%">
        <Flex
          align="center"
          position="absolute"
          h="100%"
          whiteSpace="nowrap"
          sx={{
            animation: 'idea-marquee-scroll 18s linear infinite',
            '@keyframes idea-marquee-scroll': {
              '0%': { transform: 'translateX(100%)' },
              '100%': { transform: 'translateX(-100%)' },
            },
            '&:hover': {
              animationPlayState: 'paused',
            },
          }}
        >
          <Text className="font-poppins text_medium text_sm" color="white" whiteSpace="nowrap" px={2}>
            New idea published — <strong>{notification.ideaTitle}</strong>
            &nbsp;&nbsp;·&nbsp;&nbsp;
            by {notification.author}
          </Text>
        </Flex>
      </Box>

      <Flex align="center" px={3} h="100%" flexShrink={0} zIndex={1}>
        <Icon as={ChevronRightIcon} color="white" boxSize={5} />
      </Flex>
    </Flex>
  );
};

export default IdeaPublishedMarquee;